import React, { useEffect, useState } from 'react';
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import Moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import GeoApi from '../../api/destinations';
import MesSalida from './inputs/mes-salida/selectMesSalida';
import DropDownDistribucion from './inputs/habitaciones/dropdownDistribucionHabitaciones';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import '../../commons/searcher/input-search.css';
import './buscador-vertical/buscador.css';
import './form-buscador-reusable.css';

const FormBuscador = ({
  application,
  t,
  isInList = false,
  inputIcon,
  idUnico,
}) => {
  const [origenesDestacados, setOrigenesDestacados] = useState([]);
  const [destinosDestacados, setDestinosDestacados] = useState([]);
  const [origen, setOrigen] = useState('');
  const [destino, setDestino] = useState('');
  const [FechaDesde, setFechaDesde] = useState('');
  const [FechaHasta, setFechaHasta] = useState('');
  const [mes, setMes] = useState('');
  const [productoDisp, setProductoDisp] = useState([]);
  const [defaultInputValue, setDefaultInputValue] = useState('');
  const [tituloDestacado, setTituloDestacado] = useState('');
  const [mensajeError, setMensajeError] = useState('');
  const [selected, setSelected] = useState({
    code: '',
    country_code: '',
    country_name: '',
    name: '',
    id: 0,
  });
  const [ciudades, setCiudades] = useState([]);
  const [cities, setCities] = useState([]);
  const [isOriginsLoading, setOriginsIsLoading] = useState(false);
  const [isDestinationsLoading, setDestinationsIsLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [habitaciones, setHabitaciones] = useState(1);
  const [listaHabitaciones, setListaHabitaciones] = useState([
    {
      adultos: 2,
      menores: 0,
      listaMenores: [],
    },
  ]);
  const [cantHuespedes, setCantHuespedes] = useState(2);

  const getOriginAsync = async () => {
    try {
      const origenes = [];
      const res = await GeoApi.getOriginByApi(application.token);
      res?.destacados?.forEach((destacado) => {
        origenes.push(destacado);
      });
      setOrigenesDestacados(origenes);
    } catch (e) {
      console.error(e);
    }
  };

  const getCityByCodeAsync = async (defaultInputValue) => {
    try {
      const res = await GeoApi.getCityByCode(defaultInputValue);
      setSelected({ ...res });
      setDefaultInputValue(res.name);
      setLoad(true);
    } catch (e) {
      console.error(e);
      setSelected({});
      setDefaultInputValue('');
      setLoad(true);
    }
  };

  const renderMenu = (results, menuProps) => {
    return (
      <Menu {...menuProps}>
        {tituloDestacado !== '' ? (
          <li className='dropdown-header fondo-titulo-buscador'>
            {tituloDestacado}
          </li>
        ) : null}
        {results.map((state) => (
          <MenuItem
            key={state.codigo}
            option={state}
            className='dropdown-item-destination block py-2 px-2'
          >
            <div className='flex justify-between items-center'>
              <div className='float-left'>
                <i className='fa fa-map-marker text-gray-500 pr-1' />
                {`${state.nombre} - ${state.provincia.nombre} `}
              </div>
              <div className='float-right'>
                            &nbsp;
                {' '}
                {state.codigo}
              </div>
            </div>
          </MenuItem>
        ))}
      </Menu>
    );
  };

  const getDestinationsAsync = async (query, setCitiesCallback, setIsLoading) => {
    try {
      const cities = await GeoApi.getDestinations(query);
      setCitiesCallback(cities);
      setIsLoading(false);
      renderMenu(cities);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getOriginAsync();
    if (defaultInputValue) {
      getCityByCodeAsync(defaultInputValue);
    } else {
      setLoad(true);
    }
  }, []);

  const actualizarOrigen = (item) => {
    if (item !== undefined) {
      setOrigen(item.codigo);
      GeoApi.getDestinyByApi(item.codigo, application.token).then((result) => {
        const destino = result.destacado.map((des) => des);
        setDestinosDestacados(destino);
      });
    }
    setDisabled(false);
  };

  const onChangeOrigen = (selected) => {
    let item = [
      {
        code: '',
        country_code: '',
        country_name: '',
        name: '',
        id: 0,
      },
    ];
    if (selected.length !== 0 || selected === undefined) {
      item = selected[0];
    }
    actualizarOrigen(item);
  };

  const actualizarDestino = (item) => {
    if (item !== undefined) {
      setDestino(item.codigo);
    }
    GeoApi.getMonthByApi(origen, item.codigo, application.token).then(
      (result) => {
        const fechasDisponibles = result;
        setProductoDisp(fechasDisponibles);
      },
    );
  };

  const onChangeDestino = (selected) => {
    let item = [
      {
        code: '',
        country_code: '',
        country_name: '',
        name: '',
        id: 0,
      },
    ];
    if (selected.length !== 0 || selected === undefined) {
      item = selected[0];
    }
    actualizarDestino(item);
  };

  const actualizarMesSalida = (item) => {
    setFechaDesde(item['FechaDesde']);
    setFechaHasta(item['FechaHasta']);
  };

  const clearStates = () => {
    setMensajeError('');
    setCiudades([]);
    setCities([]);
    setTituloDestacado('');
    if (window.screen.width < 768) {
      document.getElementById('origenes').removeAttribute('style');
      document.getElementById('destinos').removeAttribute('style');
    }
  };

  const formatearFecha = (fechaSeleccionada, hasta) => {
    const fechaDesdeFormatoMoment = hasta
      ? Moment(fechaSeleccionada)
      : Moment(fechaSeleccionada, 'MM-YYYY');
    let FechaDesde = fechaDesdeFormatoMoment.format('YYYY-MM-DD');
    const mesSeleccionado = fechaDesdeFormatoMoment.format('M');
    const anioSeleccionado = fechaDesdeFormatoMoment.format('YYYY');
    const mesActual = Moment().format('M').toString();
    const anioActual = Moment().format('YYYY').toString();

    if (
      !hasta
            && mesActual === mesSeleccionado
            && anioActual === anioSeleccionado
    ) {
      FechaDesde = Moment().format('YYYY-MM-DD');
    }

    setMes(Moment(mesSeleccionado, 'M').format('MMMM'));

    const FechaHasta = hasta
      ? Moment(hasta).format('YYYY-MM-DD')
      : Moment(fechaSeleccionada, 'MM YYYY')
        .endOf('month')
        .format('YYYY-MM-DD');

    actualizarMesSalida({ FechaDesde, FechaHasta });
    clearStates();
  };

  const prepararQueryString = (dateFrom, dateTo) => {
    const fechaDesde = `desde=${dateFrom}`;
    const fechaHasta = `hasta=${dateTo}`;
    return `?${fechaDesde}&${fechaHasta}`;
  };

  const handleSearch = (query) => {
    setOriginsIsLoading(true);
    if (query.length > 2) {
      setTituloDestacado('');
      getDestinationsAsync(query, setCiudades, setOriginsIsLoading);
    } else {
      setCiudades([]);
      setOrigen('');
      setTituloDestacado('Lo más buscado');
    }
  };

  const handleSearchDes = (query) => {
    setDestinationsIsLoading(true);
    if (query.length > 2) {
      setTituloDestacado('');
      getDestinationsAsync(query, setCities, setDestinationsIsLoading);
    } else {
      setCities([]);
      setDestino('');
      setTituloDestacado('Lo más buscado');
    }
  };

  const contarHuespedes = (cantidadHuespedes) => {
    listaHabitaciones.forEach((elemento) => {
      // eslint-disable-next-line no-param-reassign
      cantidadHuespedes = cantidadHuespedes + elemento.menores + elemento.adultos;
    });
    return cantidadHuespedes;
  };

  const actualizarHuespedes = () => {
    let cantidadHuespedes = 0;
    cantidadHuespedes = contarHuespedes(cantidadHuespedes);
    setCantHuespedes(cantidadHuespedes);
  };

  const cantidadHabitaciones = (val) => {
    setHabitaciones(val);
    if (val < habitaciones) {
      listaHabitaciones.pop();
    } else {
      listaHabitaciones[listaHabitaciones.length] = {
        adultos: 2,
        menores: 0,
        listaMenores: [],
      };
      setListaHabitaciones(listaHabitaciones);
    }
    actualizarHuespedes();
  };

  const actualizarMenores = (val, nroHabitacion) => {
    if (val < listaHabitaciones[nroHabitacion].menores) {
      listaHabitaciones[nroHabitacion].listaMenores.pop();
    }
    listaHabitaciones[nroHabitacion].menores = val;
    setListaHabitaciones(listaHabitaciones);
    actualizarHuespedes();
  };

  const actualizarEdadesMenores = (event, nroHabitacion) => {
    listaHabitaciones[nroHabitacion].listaMenores.push(event.target.value);
    setListaHabitaciones(listaHabitaciones);
    actualizarHuespedes();
  };

  const actualizarAdultos = (val, nroHabitacion) => {
    if (val < listaHabitaciones[nroHabitacion].adultos) {
      listaHabitaciones[nroHabitacion].listaMenores.pop();
    }
    listaHabitaciones[nroHabitacion].adultos = val;
    setListaHabitaciones(listaHabitaciones);
    actualizarHuespedes();
  };

  const prepararDatosHabitaciones = () => {
    let habitacionesQueryString = '';
    const habitaciones = listaHabitaciones;

    for (let i = 0; i < habitaciones.length; i++) {
      habitacionesQueryString += habitaciones[i].adultos;

      if (habitaciones[i].menores > 0) {
        habitaciones[i].listaMenores.forEach((edadMenor) => {
          habitacionesQueryString += `-${edadMenor}`;
        });
      }
      if (habitaciones[i + 1]) {
        habitacionesQueryString += '!';
      }
    }
    return habitacionesQueryString;
  };

  const submitForm = (e) => {
    if (
      origen === ''
            || destino === ''
            || FechaDesde === ''
            || origen === undefined
            || destino === undefined
            || FechaDesde === undefined
    ) {
      e.preventDefault();
      if (window.screen.width < 768) {
        if (origen === '' || origen === undefined) {
          document
            .getElementById('origenes')
            .setAttribute(
              'style',
              'border: 1px solid #ff0000; border-radius:5px',
            );
        }
        if (destino === '' || destino === undefined) {
          document
            .getElementById('destinos')
            .setAttribute(
              'style',
              'border: 1px solid #ff0000; border-radius:5px',
            );
        }
      }
    }
  };

  const queryString = prepararQueryString(FechaDesde, FechaHasta);

  return (
    <form className={`w-full ${isInList ? 'overwrite-list' : ''}`}>
      <div className='search-content search_package_main flex justify-between gap-2'>
        <div className={isInList ? 'hidden' : 'col-span-12 md:col-span-1'}>
          <div className='h-full flex md:justify-left items-center text-sm pl-2 md:pl-0'>
            <i className='fas fa-suitcase lable_icon text-xs' />
            <span className='ml-1 text-gray-700'>{t('searcher.package')}</span>
          </div>
        </div>
        <div className='form-element'>
          <div className='input-padding'>
            <div
              className={
                inputIcon ? 'container-geo-s input-group' : 'container-geo-s'
              }
              id='origenes'
            >
              <AsyncTypeahead
                className='border-l-0 border-t-0 border-r-0'
                id={`buscador-o-${idUnico}`}
                placeholder={t('searcher.origin')}
                onSearch={handleSearch}
                onChange={onChangeOrigen}
                onInputChange={clearStates}
                onFocus={clearStates}
                options={ciudades.length > 0 ? ciudades : origenesDestacados}
                minLength={0}
                filterBy={['nombre', 'codigo', 'country_code', 'country_name']}
                labelKey='codigo'
                renderMenu={renderMenu}
                isLoading={isOriginsLoading}
              />
              {mensajeError !== '' && origen === '' ? (
                <div
                  className='panel panel-default panel-para-mensaje-error color-dinamico-fondo hidden-xs'
                >
                  <div className='panel-body' style={{ color: '#ffffff' }}>
                    {mensajeError}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className='form-element'>
          <div className='input-padding'>
            <div
              className={
                inputIcon ? 'container-geo-s input-group' : 'container-geo-s'
              }
              id='destinos'
            >
              <AsyncTypeahead
                id={`buscador-d-${idUnico}`}
                placeholder={t('searcher.destination')}
                onSearch={handleSearchDes}
                onChange={onChangeDestino}
                onInputChange={clearStates}
                onFocus={clearStates}
                options={cities.length > 0 ? cities : destinosDestacados}
                filterBy={['nombre', 'codigo', 'country_code', 'country_name']}
                labelKey='codigo'
                minLength={0}
                renderMenu={renderMenu}
                disabled={disabled}
                isLoading={isDestinationsLoading}
              />
              {mensajeError !== '' && destino === '' ? (
                <div
                  className='panel panel-default panel-para-mensaje-error color-dinamico-fondo hidden-xs'
                >
                  <div className='panel-body' style={{ color: '#ffffff' }}>
                    {mensajeError}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className='flex justify-between items-baseline flex-wrap gap-1'>
          <div className='form-group aux'>
            <MesSalida
              mesSalida={Moment(FechaDesde).format('MM-YYYY')}
              ActualizarFecha={formatearFecha}
              productoDisponible={productoDisp}
            />
            {mensajeError !== '' && mes === '' ? (
              <div className='panel panel-default panel-para-mensaje-error color-dinamico-fondo'>
                <div className='panel-body' style={{ color: '#ffffff' }}>
                  {mensajeError}
                </div>
              </div>
            ) : null}
          </div>
          <DropDownDistribucion
            isInList={isInList}
            className='input-paquetes'
            ancho='155%'
            cantidadHabitaciones={cantidadHabitaciones}
            actualizarEdadesMenores={actualizarEdadesMenores}
            actualizarAdultos={actualizarAdultos}
            actualizarMenores={actualizarMenores}
            habitaciones={habitaciones}
            cant_huespedes={cantHuespedes}
            listaHabitaciones={listaHabitaciones}
          />
        </div>
        <div className='flex justify-between items-center f-1'>
          <a
            href={`/packages/list/${origen}/${destino}/${mes}/${prepararDatosHabitaciones()}${queryString}`}
            onClick={submitForm}
            // target='_blank'
            rel='noopener noreferrer'
            className='flex justify-center items-center search_button p-2 h-full rounded-md md:rounded py-2.5 md-py-0'
            style={{ width: '100%' }}
          >
            <div>
              <i className='fas fa-search' style={{ marginRight: '.5rem' }} />
              Buscar
            </div>
          </a>
        </div>
      </div>
    </form>
  );
};

FormBuscador.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    application: state.applicationState,
  };
};

export default connect(
  mapStateToProps,
  null,
)(withTranslation(['layout'])(FormBuscador));
